<template>
    <div class="kt-heading kt-heading--md">
        <span class="kt-badge kt-badge--brand kt-badge--lg">{{actual.numero}}</span>
        {{actual.titulo}}
        <hr>
    </div>
</template>

<script>
    export default {
        name: "wizard-titulo",
        data:()=>({

        }),
        computed:{
            actual:function(){
                return this.$store.getters.getPasoActual;
            }
        },
        created() {

        }
    }
</script>

<style scoped>
    .kt-wizard-v1 .kt-wizard-v1__wrapper .kt-form .kt-wizard-v1__content {
        padding-bottom: 0px;
    }

</style>
